import { useState } from "react";
import { PlayCircle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const SRC = "/manuali/Video_Accesso_CRM_Trust_Master.mp4";

export function VideoGuideLink() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="login-video-guide-link"
        className="mt-4 w-full flex items-center justify-center gap-2 text-sm font-medium text-sky-700 hover:text-sky-900 transition-colors">
        <PlayCircle className="h-5 w-5" />Guarda il video guida
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl bg-white p-4" data-testid="login-video-dialog">
          <DialogHeader>
            <DialogTitle className="font-heading">Come accedere al CRM Trust Master</DialogTitle>
            <DialogDescription>Guida passo passo, circa 2 minuti e mezzo.</DialogDescription>
          </DialogHeader>
          {open && <video src={SRC} controls autoPlay playsInline className="w-full rounded-lg bg-black aspect-video" data-testid="login-video-player" />}
        </DialogContent>
      </Dialog>
    </>
  );
}
